import { getTheme } from '@fluentui/react';

const { palette } = getTheme();

const TAG_COLORS: string[] = [palette.themePrimary, '#106ebe', '#742774', '#077568', '#6264a7', '#3955a3', '#008272'];
const TAG_COLOR_COUNT = TAG_COLORS.length;

// getTagColorFromString: Given a string, return a color analogous to the current fabric theme primary color.
export function getTagColorHexFromString(text: string | undefined): string {
  let color = TAG_COLORS[0];
  if (!text) {
    return color;
  }

  let hashCode = 0;
  for (let iLen: number = text.length - 1; iLen >= 0; iLen--) {
    const ch: number = text.charCodeAt(iLen);
    const shift: number = iLen % 8;
    hashCode ^= (ch << shift) + (ch >> (8 - shift));
  }

  color = TAG_COLORS[hashCode % TAG_COLOR_COUNT];

  return color;
}
